import { render, staticRenderFns } from "./thread.vue?vue&type=template&id=35f9ca23&scoped=true"
import script from "./thread.vue?vue&type=script&lang=js"
export * from "./thread.vue?vue&type=script&lang=js"
import style0 from "./thread.vue?vue&type=style&index=0&id=35f9ca23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f9ca23",
  null
  
)

export default component.exports